module.exports = __webpack_public_path__ + "static/media/waaa.30e02bed.ogg";